"use client";

import { type ReactElement } from "react";
import { usePathname } from "next/navigation";

function isReadingRoute(pathname: string): boolean {
  return (
    pathname === "/research" ||
    pathname.startsWith("/blog") ||
    pathname.startsWith("/careers")
  );
}

/**
 * Sits above the particle layer (z-0) and below main (z-10) on reading routes only,
 * darkening the simulation without relying on canvas filters.
 */
export function ConditionalReadingScrim(): ReactElement | null {
  const pathname = usePathname();
  if (!isReadingRoute(pathname)) return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[5] bg-black/18 dark:bg-[#03050a]/48"
      aria-hidden
    />
  );
}
